import { GridColumnProps } from "@progress/kendo-react-grid";
import { CLASSNAME, ICON_NAMES } from "utils/constant";
import { GrideDateFormatter } from "ui/Date";
import { NumericalCell, NumericalHeader } from "ui/grid/GridCommandCell";
import { t } from "i18next";
import { IconButtonActionType } from "interface/index";

export const registrationOverviewGridColumns = ({
	onViewLandingNote,
	onViewSalesNote,
}: {
	onViewLandingNote?: (data: any) => void;
	onViewSalesNote?: (data: any) => void;
}) => {
	const gridItems: GridColumnProps[] = [
		{
			field: "registrationId",
			title: t("NumberShort"),
			width: "110px",
			headerClassName: "no-border",
		},
		{
			field: "registrationTime",
			title: t("RegistrationDate"),
			width: "120px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.registrationTime}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
		},
		{
			field: "landingTime",
			title: t("LandingDate"),
			width: "120px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.landingTime}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
		},
		{
			field: "vesselRegistrationId",
			title: t("VesselRegistrationId"),
			width: "110px",
			headerClassName: "no-border",
		},
		{
			field: "vesselName",
			title: t("VesselName"),
			headerClassName: "no-border",
		},
		{
			field: "species",
			title: t("Species"),
			width: "140px",
			headerClassName: "no-border",
		},
		{
			field: "catchField",
			title: t("CatchField"),
			width: "90px",
			headerClassName: "no-border",
		},
		{
			field: "netLiveWeightKg",
			title: t("Quantity"),
			width: "120px",
			headerClassName: "no-border",
			headerCell: (props) => (
				<NumericalHeader {...props} title={t("Quantity")} />
			),
			cells: {
				data: (props) => (
					<NumericalCell {...props} field="netLiveWeightKg" format="# ##0.00" />
				),
			},
		},
		{
			field: "fishingGear",
			title: t("FishingGear"),
			width: "160px",
			headerClassName: "no-border",
		},
	];

	const actionItems: GridColumnProps[] = [
		{
			field: "",
			title: "",
			width: "45px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<td>
						{props.dataItem.numberOfLandingNotes > 0 && (
							<button
								className="k-button k-button-sm k-button-solid k-button-solid-base"
								style={{ minWidth: 28 }}
								title={t("LandingNote")}
								onClick={() => onViewLandingNote?.(props.dataItem)}
							>
								L
							</button>
						)}
					</td>
				),
			},
		},
		{
			field: "",
			title: "",
			width: "45px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<td>
						{props.dataItem.numberOfSalesNotes > 0 && (
							<button
								className="k-button k-button-sm k-button-solid k-button-solid-base"
								style={{ minWidth: 28 }}
								title={t("SalesNote")}
								onClick={() => onViewSalesNote?.(props.dataItem)}
							>
								S
							</button>
						)}
					</td>
				),
			},
		},
	];

	return [...gridItems];
};

export const lastColumItems = ({ edit }: { edit?: (data: any) => void }) => {
	const items: any[] = [
		{
			onclick: edit,
			title: t("Edit"),
			conditionField: "status",
			iconName: ICON_NAMES.Edit,
			showConditionValue: 0,
			// actionType: IconButtonActionType.Update,
		},
		{
			conditionField: "status",
			iconName: ICON_NAMES.GreenCheckbox,
			showConditionValue: 1,
		},
		{
			conditionField: "status",
			iconName: ICON_NAMES.Checkbox,
			showConditionValue: 0,
		},
	];

	return items;
};
